import { AccountType } from "@packages/chat-sdk";
import { Store } from "./store";
export interface DamselfishStoreType {
  accountsMap: Record<string, AccountType>;
}

export const damselfishStore = new Store<DamselfishStoreType>(() => ({
  accountsMap: {},
}));
export const damselfishStoreActions = {
  setAccountsMap(payload: Record<string, AccountType>) {
    damselfishStore.set({
      accountsMap: payload,
    });
  },
};
